import { render } from "./WebLayout.vue?vue&type=template&id=63647dca&scoped=true"
import script from "./WebLayout.vue?vue&type=script&lang=js"
export * from "./WebLayout.vue?vue&type=script&lang=js"

import "./WebLayout.vue?vue&type=style&index=0&id=63647dca&scoped=true&lang=css"

import exportComponent from "C:\\Users\\frval\\real-gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63647dca"]])

export default __exports__